module.exports = __webpack_public_path__ + "static/2-a2c5c52a969b94ddf4b7a7ebd3ce35da.png";